import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { cloneDeep, isArray } from 'lodash';
import { JOVE_PRICE_UNIT_CURRENCY_KEY, JOVE_PRICE_UNIT_PERCENT_KEY } from '../../constants/common';
import { BI_COW_COVER, BOP_HIRED_NON_OWNED_AUTO_COVER, BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER, BOP_PROPERTY, BOP_TERRORISM_COVER, BUSINESS_INTERUPTION, BUSINESS_OWNERS_POLICY_CLAIM_COVER, BUSINESS_OWNERS_POLICY_COVER, CL_EXCESS_COVER, CL_MEDIA_LIABILITY_COVER, CL_TERRORISM_COVER, CMR_COVER, CRIME_COVER, CRIME_EXCESS_COVER, CYBER_LIABILITY_COVER, DIRECTORS_OFFICERS_COVER, DRIVERS_NEGLIGENCE, EMPLOYERS_LIABILITY, EMPLOYMENT_PRACTICES_COVER, EXCESS_LEVEL, FIDELITY_CRIME, GOODS_IN_TRANSIT, LEGAL_EXPENSES_COVER, PACKAGE_COVER, PI_CONTINGENT_BODILY_INJURY_COVER, PI_WAIVER_OF_SUBROGATION_COVER, PL_HIRED_NON_OWNED_AUTO_COVER, PL_PRIMARY_NON_CONTRIBUTORY_COVER, PL_PROPERTY_AND_EQUIPMENT_COVER, PL_TERRORISM_COVER, PL_WAIVER_OF_SUBROGATION_COVER, PROFESSIONAL_INDEMNITY, PROFESSIONAL_INDEMNITY_CLAIM_COVER, PROPERTY_COVER_TYPE_LIST, PROPERTY_EXCESS_COVER, PUBLIC_LIABILITY, PUBLIC_LIABILITY_CLAIM_COVER } from '../../constants/coverage';
import { PROVIDER_SOURCE, getPaymentScheduleStatusMap } from '../../constants/quote';
import { formatCurrency } from '../../shared/formatters';
import { addNumbers, divideNumber, multiplyNumber } from '../../utils/decimal';
import { subtractNumbers } from '../../utils/decimal';
import { getLocalTranslation } from '../../utils/i18nKit';
import { formatCommonDateStr, transformDateStrToTimeString } from '../../utils/time';

var formatPriceText = function formatPriceText(amount, currency) {
  return formatCurrency({
    amount: amount || 0,
    currency: currency
  });
};

export var handleQuotePriceDateInfo = function handleQuotePriceDateInfo(resData) {
  if (!resData) return void 0; // Compatible with previous code logic: Modify the price data so that price represents the current price to be paid

  if (isArray(resData === null || resData === void 0 ? void 0 : resData.billing_schedule)) {
    var currentPriceItem = resData.billing_schedule.find(function (item) {
      return !!item.current_period;
    });

    if (currentPriceItem && currentPriceItem.price) {
      resData.price = _objectSpread(_objectSpread({}, resData.price), {}, {
        price: currentPriceItem.price.price,
        tax: currentPriceItem.price.tax,
        total: currentPriceItem.price.total,
        admin_fee: currentPriceItem.price.admin_fee,
        processing_fee: currentPriceItem.price.processing_fee
      });
    }
  } // Basic data


  var _handleCommonPriceDat = handleCommonPriceData(resData),
      data = _handleCommonPriceDat.data,
      priceData = _handleCommonPriceDat.priceData; // pi, pl, el, exl, git, cmr


  var _handleCommonInsurerP = handleCommonInsurerPriceData(data, priceData),
      _handleCommonInsurerP2 = _slicedToArray(_handleCommonInsurerP, 2),
      res1 = _handleCommonInsurerP2[0],
      res2 = _handleCommonInsurerP2[1];

  var priceDataInfo = _objectSpread(_objectSpread(_objectSpread({}, res1), res2), {}, {
    covers: _objectSpread({}, resData === null || resData === void 0 ? void 0 : resData.covers)
  });

  generateCustomCalculateCombinedPriceInfo(priceDataInfo);
  return priceDataInfo;
};

var generateCustomCombinedSubCoveragePriceInfo = function generateCustomCombinedSubCoveragePriceInfo(priceDataInfo, coverageKeyList) {
  var list = [];

  var _ref = priceDataInfo || {},
      aggregate_covers_price = _ref.aggregate_covers_price,
      currency = _ref.currency;

  (coverageKeyList || []).forEach(function (key) {
    if (aggregate_covers_price !== null && aggregate_covers_price !== void 0 && aggregate_covers_price[key]) {
      list.push(_objectSpread(_objectSpread({}, aggregate_covers_price[key]), {}, {
        key: key,
        priceText: formatPriceText(aggregate_covers_price[key].price, currency),
        totalText: formatPriceText(aggregate_covers_price[key].total, currency)
      }));
    }
  });
  return list;
};

var generateBrokerCommissionChainList = function generateBrokerCommissionChainList(data) {
  var _ref2 = data || {},
      sub_broker_fees = _ref2.sub_broker_fees,
      broker_commission = _ref2.broker_commission,
      broker_commission_amount = _ref2.broker_commission_amount,
      broker_commission_discount = _ref2.broker_commission_discount,
      broker_commission_discount_amount = _ref2.broker_commission_discount_amount,
      broker_commission_type = _ref2.broker_commission_type,
      broker_fee = _ref2.broker_fee,
      broker_fee_amount = _ref2.broker_fee_amount,
      broker_fee_type = _ref2.broker_fee_type,
      entity_id = _ref2.entity_id,
      parent_id = _ref2.parent_id,
      promotion_id = _ref2.promotion_id;

  var list = cloneDeep(sub_broker_fees || []);
  list.unshift({
    broker_commission: broker_commission,
    broker_commission_amount: broker_commission_amount,
    broker_commission_type: broker_commission_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    broker_commission_discount: broker_commission_discount,
    broker_commission_discount_amount: broker_commission_discount_amount,
    broker_commission_discount_type: broker_commission_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    broker_fee: broker_fee,
    broker_fee_amount: broker_fee_amount,
    broker_fee_type: broker_fee_type || JOVE_PRICE_UNIT_PERCENT_KEY,
    entity_id: entity_id,
    parent_id: parent_id,
    promotion_id: promotion_id
  });
  return list;
};

var generateBrokerCommissionDetailsInfoWithBrokerCommissionChainList = function generateBrokerCommissionDetailsInfoWithBrokerCommissionChainList(list) {
  var _currentItem, _currentItem2, _currentItem3, _currentItem4, _currentItem5, _currentItem6, _currentItem7, _currentItem8, _currentItem9, _parentItem, _parentItem2, _parentItem3, _parentItem4, _parentItem5, _parentItem6, _parentItem7, _parentItem8, _parentItem9;

  var currentItem = null;
  var parentItem = null;

  if ((list === null || list === void 0 ? void 0 : list.length) > 1) {
    parentItem = list[0];
    currentItem = list[list.length - 1];
  }

  if ((list === null || list === void 0 ? void 0 : list.length) === 1) {
    currentItem = list[list.length - 1];
  }

  return {
    broker_commission: (_currentItem = currentItem) === null || _currentItem === void 0 ? void 0 : _currentItem.broker_commission,
    broker_commission_type: (_currentItem2 = currentItem) === null || _currentItem2 === void 0 ? void 0 : _currentItem2.broker_commission_type,
    broker_commission_amount: (_currentItem3 = currentItem) === null || _currentItem3 === void 0 ? void 0 : _currentItem3.broker_commission_amount,
    broker_commission_discount: (_currentItem4 = currentItem) === null || _currentItem4 === void 0 ? void 0 : _currentItem4.broker_commission_discount,
    broker_commission_discount_type: (_currentItem5 = currentItem) === null || _currentItem5 === void 0 ? void 0 : _currentItem5.broker_commission_discount_type,
    broker_commission_discount_amount: (_currentItem6 = currentItem) === null || _currentItem6 === void 0 ? void 0 : _currentItem6.broker_commission_discount_amount,
    broker_fee: (_currentItem7 = currentItem) === null || _currentItem7 === void 0 ? void 0 : _currentItem7.broker_fee,
    broker_fee_type: (_currentItem8 = currentItem) === null || _currentItem8 === void 0 ? void 0 : _currentItem8.broker_fee_type,
    broker_fee_amount: (_currentItem9 = currentItem) === null || _currentItem9 === void 0 ? void 0 : _currentItem9.broker_fee_amount,
    wholesale_broker_commission: (_parentItem = parentItem) === null || _parentItem === void 0 ? void 0 : _parentItem.broker_commission,
    wholesale_broker_commission_type: (_parentItem2 = parentItem) === null || _parentItem2 === void 0 ? void 0 : _parentItem2.broker_commission_type,
    wholesale_broker_commission_amount: (_parentItem3 = parentItem) === null || _parentItem3 === void 0 ? void 0 : _parentItem3.broker_commission_amount,
    wholesale_broker_commission_discount: (_parentItem4 = parentItem) === null || _parentItem4 === void 0 ? void 0 : _parentItem4.broker_commission_discount,
    wholesale_broker_commission_discount_type: (_parentItem5 = parentItem) === null || _parentItem5 === void 0 ? void 0 : _parentItem5.broker_commission_discount_type,
    wholesale_broker_commission_discount_amount: (_parentItem6 = parentItem) === null || _parentItem6 === void 0 ? void 0 : _parentItem6.broker_commission_discount_amount,
    wholesale_broker_fee: (_parentItem7 = parentItem) === null || _parentItem7 === void 0 ? void 0 : _parentItem7.broker_fee,
    wholesale_broker_fee_type: (_parentItem8 = parentItem) === null || _parentItem8 === void 0 ? void 0 : _parentItem8.broker_fee_type,
    wholesale_broker_fee_amount: (_parentItem9 = parentItem) === null || _parentItem9 === void 0 ? void 0 : _parentItem9.broker_fee_amount
  };
};

var calculateMainCoveragePriceInfo = function calculateMainCoveragePriceInfo(mainKey, subKeyList, priceDataInfo) {
  var _aggregate_covers_pri, _aggregate_covers_pri2;

  var _ref3 = priceDataInfo || {},
      provider_code = _ref3.provider_code,
      aggregate_covers_price = _ref3.aggregate_covers_price,
      currency = _ref3.currency;

  var mainPrice = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri = aggregate_covers_price[mainKey]) === null || _aggregate_covers_pri === void 0 ? void 0 : _aggregate_covers_pri.price) || 0;
  var mainTotal = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri2 = aggregate_covers_price[mainKey]) === null || _aggregate_covers_pri2 === void 0 ? void 0 : _aggregate_covers_pri2.total) || 0;
  (subKeyList || []).forEach(function (key) {
    var _aggregate_covers_pri3, _aggregate_covers_pri4;

    mainPrice = subtractNumbers(mainPrice, (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri3 = aggregate_covers_price[key]) === null || _aggregate_covers_pri3 === void 0 ? void 0 : _aggregate_covers_pri3.price) || 0);
    mainTotal = subtractNumbers(mainTotal, (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri4 = aggregate_covers_price[key]) === null || _aggregate_covers_pri4 === void 0 ? void 0 : _aggregate_covers_pri4.total) || 0);
  });
  return {
    key: mainKey,
    price: mainPrice,
    total: mainTotal,
    priceText: formatPriceText(mainPrice, currency),
    totalText: formatPriceText(mainTotal, currency)
  };
};

var generateCustomCalculateCombinedPriceInfo = function generateCustomCalculateCombinedPriceInfo(priceDataInfo) {
  var _ref4 = priceDataInfo || {},
      provider_code = _ref4.provider_code,
      aggregate_covers_price = _ref4.aggregate_covers_price,
      currency = _ref4.currency;

  var list = [];

  if ([PROVIDER_SOURCE().HISCOX_US.value].includes(provider_code)) {
    if (aggregate_covers_price !== null && aggregate_covers_price !== void 0 && aggregate_covers_price[PROFESSIONAL_INDEMNITY]) {
      var subKeyList = [PROFESSIONAL_INDEMNITY_CLAIM_COVER, EXCESS_LEVEL, PI_CONTINGENT_BODILY_INJURY_COVER, PI_WAIVER_OF_SUBROGATION_COVER];
      var subCoverageList = generateCustomCombinedSubCoveragePriceInfo(priceDataInfo, subKeyList);
      subCoverageList.unshift(_objectSpread(_objectSpread({}, aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : aggregate_covers_price[PROFESSIONAL_INDEMNITY]), calculateMainCoveragePriceInfo(PROFESSIONAL_INDEMNITY, subKeyList, priceDataInfo)));
      list.push(_objectSpread(_objectSpread({}, aggregate_covers_price[PROFESSIONAL_INDEMNITY]), {}, {
        key: PROFESSIONAL_INDEMNITY,
        priceText: formatPriceText(aggregate_covers_price[PROFESSIONAL_INDEMNITY].price, currency),
        totalText: formatPriceText(aggregate_covers_price[PROFESSIONAL_INDEMNITY].total, currency),
        subCoverageList: subCoverageList
      }));
    }

    if (aggregate_covers_price !== null && aggregate_covers_price !== void 0 && aggregate_covers_price[PUBLIC_LIABILITY]) {
      var _subKeyList = [PUBLIC_LIABILITY_CLAIM_COVER, PL_PROPERTY_AND_EQUIPMENT_COVER, PL_HIRED_NON_OWNED_AUTO_COVER, PL_TERRORISM_COVER, PL_WAIVER_OF_SUBROGATION_COVER, PL_PRIMARY_NON_CONTRIBUTORY_COVER];

      var _subCoverageList = generateCustomCombinedSubCoveragePriceInfo(priceDataInfo, _subKeyList);

      _subCoverageList.unshift(_objectSpread(_objectSpread({}, aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : aggregate_covers_price[PUBLIC_LIABILITY]), calculateMainCoveragePriceInfo(PUBLIC_LIABILITY, _subKeyList, priceDataInfo)));

      list.push(_objectSpread(_objectSpread({}, aggregate_covers_price[PUBLIC_LIABILITY]), {}, {
        key: PUBLIC_LIABILITY,
        priceText: formatPriceText(aggregate_covers_price[PUBLIC_LIABILITY].price, currency),
        totalText: formatPriceText(aggregate_covers_price[PUBLIC_LIABILITY].total, currency),
        subCoverageList: _subCoverageList
      }));
    }

    if (aggregate_covers_price !== null && aggregate_covers_price !== void 0 && aggregate_covers_price[BUSINESS_OWNERS_POLICY_COVER]) {
      var _subKeyList2 = [BUSINESS_OWNERS_POLICY_CLAIM_COVER, BOP_PROPERTY, PROPERTY_EXCESS_COVER, BOP_HIRED_NON_OWNED_AUTO_COVER, BOP_HIRED_NON_OWNED_AUTO_EXCESS_COVER, CRIME_COVER, CRIME_EXCESS_COVER, BOP_TERRORISM_COVER];

      var _subCoverageList2 = generateCustomCombinedSubCoveragePriceInfo(priceDataInfo, _subKeyList2);

      _subCoverageList2.unshift(_objectSpread(_objectSpread({}, aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : aggregate_covers_price[BUSINESS_OWNERS_POLICY_COVER]), calculateMainCoveragePriceInfo(BUSINESS_OWNERS_POLICY_COVER, _subKeyList2, priceDataInfo)));

      list.push(_objectSpread(_objectSpread({}, aggregate_covers_price[BUSINESS_OWNERS_POLICY_COVER]), {}, {
        key: BUSINESS_OWNERS_POLICY_COVER,
        priceText: formatPriceText(aggregate_covers_price[BUSINESS_OWNERS_POLICY_COVER].price, currency),
        totalText: formatPriceText(aggregate_covers_price[BUSINESS_OWNERS_POLICY_COVER].total, currency),
        subCoverageList: _subCoverageList2
      }));
    }

    if (aggregate_covers_price !== null && aggregate_covers_price !== void 0 && aggregate_covers_price[CYBER_LIABILITY_COVER]) {
      var _subKeyList3 = [CL_EXCESS_COVER, CL_TERRORISM_COVER, CL_MEDIA_LIABILITY_COVER];

      var _subCoverageList3 = generateCustomCombinedSubCoveragePriceInfo(priceDataInfo, _subKeyList3);

      _subCoverageList3.unshift(_objectSpread(_objectSpread({}, aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : aggregate_covers_price[CYBER_LIABILITY_COVER]), calculateMainCoveragePriceInfo(CYBER_LIABILITY_COVER, _subKeyList3, priceDataInfo)));

      list.push(_objectSpread(_objectSpread({}, aggregate_covers_price[CYBER_LIABILITY_COVER]), {}, {
        key: CYBER_LIABILITY_COVER,
        priceText: formatPriceText(aggregate_covers_price[CYBER_LIABILITY_COVER].price, currency),
        totalText: formatPriceText(aggregate_covers_price[CYBER_LIABILITY_COVER].total, currency),
        subCoverageList: _subCoverageList3
      }));
    }
  }

  priceDataInfo.customCombinedCoverageList = list;
};

var appendExtraDataToPriceItem = function appendExtraDataToPriceItem(price) {
  if (!price) {
    return price;
  }

  var brokerCommmissionChain = generateBrokerCommissionChainList(price);
  return _objectSpread(_objectSpread({}, price), generateBrokerCommissionDetailsInfoWithBrokerCommissionChainList(brokerCommmissionChain));
};

var handleCommonPriceData = function handleCommonPriceData(data) {
  var _data$annual_billing_, _priceData, _priceData2, _priceData3, _priceData4, _priceData5;

  // Total price info
  var _ref5 = (data === null || data === void 0 ? void 0 : data.aggregate_prices) || {},
      total = _ref5.total,
      total_before_promotion = _ref5.total_before_promotion,
      admin_fee = _ref5.admin_fee,
      processing_fee = _ref5.processing_fee,
      currency = _ref5.currency,
      price = _ref5.price,
      tax = _ref5.tax,
      original_price = _ref5.original_price,
      underwriting_fee = _ref5.underwriting_fee,
      underwriting_fee_type = _ref5.underwriting_fee_type,
      underwriting_fee_amount = _ref5.underwriting_fee_amount,
      override_price = _ref5.override_price,
      difference_price = _ref5.difference_price,
      jove_commission_discount_amount = _ref5.jove_commission_discount_amount;

  var billingScheduleCalculateTotal = 0;
  ((data === null || data === void 0 ? void 0 : data.billing_schedule) || []).forEach(function (item) {
    var _item$price;

    billingScheduleCalculateTotal += Number(((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.total) || 0);
  });
  var brokerCommmissionChain = generateBrokerCommissionChainList(data === null || data === void 0 ? void 0 : data.aggregate_prices);

  var _generateBrokerCommis = generateBrokerCommissionDetailsInfoWithBrokerCommissionChainList(brokerCommmissionChain),
      broker_commission = _generateBrokerCommis.broker_commission,
      broker_commission_type = _generateBrokerCommis.broker_commission_type,
      broker_commission_amount = _generateBrokerCommis.broker_commission_amount,
      broker_commission_discount = _generateBrokerCommis.broker_commission_discount,
      broker_commission_discount_amount = _generateBrokerCommis.broker_commission_discount_amount,
      broker_fee = _generateBrokerCommis.broker_fee,
      broker_fee_type = _generateBrokerCommis.broker_fee_type,
      broker_fee_amount = _generateBrokerCommis.broker_fee_amount,
      wholesale_broker_commission = _generateBrokerCommis.wholesale_broker_commission,
      wholesale_broker_commission_type = _generateBrokerCommis.wholesale_broker_commission_type,
      wholesale_broker_commission_amount = _generateBrokerCommis.wholesale_broker_commission_amount,
      wholesale_broker_fee = _generateBrokerCommis.wholesale_broker_fee,
      wholesale_broker_fee_type = _generateBrokerCommis.wholesale_broker_fee_type,
      wholesale_broker_fee_amount = _generateBrokerCommis.wholesale_broker_fee_amount,
      wholesale_broker_commission_discount = _generateBrokerCommis.wholesale_broker_commission_discount,
      wholesale_broker_commission_discount_amount = _generateBrokerCommis.wholesale_broker_commission_discount_amount;

  data.price = appendExtraDataToPriceItem(data === null || data === void 0 ? void 0 : data.price);
  var currentPayData = data === null || data === void 0 ? void 0 : data.price; // Discount

  var customDiscountAmount = Number(jove_commission_discount_amount || 0);
  var totalDiscount = 0;
  brokerCommmissionChain.forEach(function (item) {
    totalDiscount = addNumbers(totalDiscount, item.broker_commission_discount_amount);
  });
  var priceData = {
    brokerCommmissionChain: brokerCommmissionChain,
    currency: currency,
    totalText: formatPriceText(total, currency),
    totalBeforePromotionText: formatPriceText(total_before_promotion !== null && total_before_promotion !== void 0 ? total_before_promotion : 0, currency),
    totalDiscountRate: !!total_before_promotion && !!total ? parseFloat(multiplyNumber(1 - divideNumber(total, total_before_promotion), 100).toFixed(2)) : 0,
    subtotalText: formatPriceText(price, currency),
    adminFeeText: formatPriceText(admin_fee, currency),
    processingFee: processing_fee,
    processingFeeText: formatPriceText(processing_fee, currency),
    taxText: formatPriceText(tax, currency),
    haveTax: !!Number(tax || 0),
    originalPriceText: formatPriceText(original_price, currency),
    priceText: formatPriceText(price, currency),
    priceHaveDiscount: !!original_price && original_price !== price,
    currentPaySubtotal: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.price, currency),
    currentPayTotalPremiumText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.price, currency),
    currentPayTax: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.tax, currency),
    currentPayTaxText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.tax, currency),
    currentPayProcessFee: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.processing_fee, currency),
    currentPayProcessFeeText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.processing_fee, currency),
    currentPayAdminFee: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.admin_fee, currency),
    currentPayAdminFeeText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.admin_fee, currency),
    currentPayPrice: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.total, currency),
    currentOriginPrice: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.original_price, currency),
    currentOriginTotal: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.original_total, currency),
    annualDiscountRate: Number((_data$annual_billing_ = data === null || data === void 0 ? void 0 : data.annual_billing_discount) !== null && _data$annual_billing_ !== void 0 ? _data$annual_billing_ : 0),
    billingScheduleCalculateTotal: billingScheduleCalculateTotal,
    billingScheduleCalculateTotalText: formatPriceText(billingScheduleCalculateTotal, currency),
    partnerFeeText: formatPriceText(broker_fee_amount, currency),
    brokerCommisionText: formatPriceText(broker_commission_amount, currency),
    haveBrokerCommissionValue: !!Number(broker_commission_amount || 0),
    currentPayBrokerCommisionText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.broker_commission_amount, currency),
    brokerCommisionPercentageText: broker_commission_type !== JOVE_PRICE_UNIT_CURRENCY_KEY && broker_commission ? "".concat(broker_commission || 0, "%") : '',
    wholeSaleBrokerCommisionText: formatPriceText(wholesale_broker_commission_amount, currency),
    haveWholeSaleBrokerCommissionValue: !!Number(wholesale_broker_commission_amount || 0),
    currentPayWholeSaleBrokerCommisionText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.wholesale_broker_commission_amount, currency),
    wholeSaleBrokerCommisionPercentageText: wholesale_broker_commission_type !== JOVE_PRICE_UNIT_CURRENCY_KEY && wholesale_broker_commission ? "".concat(wholesale_broker_commission || 0, "%") : '',
    brokerFeeText: formatPriceText(broker_fee_amount, currency),
    haveBrokerFeeValue: !!Number(broker_fee_amount || 0),
    currentPayBrokerFeeText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.broker_fee_amount, currency),
    brokerFeePercentageText: broker_fee_type === JOVE_PRICE_UNIT_PERCENT_KEY ? "".concat(broker_fee || 0, "%") : '',
    wholeSaleBrokerFeeAmount: wholesale_broker_fee_amount || 0,
    haveWholeSaleBrokerFeeValue: !!Number(wholesale_broker_fee_amount || 0),
    currentPayWholeSaleBrokerFeeAmount: (currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.wholesale_broker_fee_amount) || 0,
    wholeSaleBrokerFeePercentageText: wholesale_broker_fee_type === JOVE_PRICE_UNIT_PERCENT_KEY ? "".concat(wholesale_broker_fee || 0, "%") : '',
    combineBrokerFeeText: formatPriceText(broker_fee_amount + (wholesale_broker_fee_amount || 0), currency),
    haveCombineBrokerFeeValue: !!Number((broker_fee_amount || 0) + (wholesale_broker_fee_amount || 0)),
    currentPayCombineBrokerFeeText: formatPriceText((currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.broker_fee_amount) + ((currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.wholesale_broker_fee_amount) || 0), currency),
    underwritingFeeText: formatPriceText(underwriting_fee_amount, currency),
    currentPayUnderwritingFeeText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.underwriting_fee_amount, currency),
    underwritingPercentageText: underwriting_fee_type === JOVE_PRICE_UNIT_PERCENT_KEY ? "".concat(underwriting_fee || 0, "%") : '',
    brokerDiscountText: formatPriceText(broker_commission_discount_amount, currency),
    haveBrokerDiscountValue: !!Number(broker_commission_discount_amount || 0),
    currentPayBrokerDiscountText: formatPriceText(currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.broker_commission_discount_amount, currency),
    brokerDiscountPercentageText: broker_commission_type !== JOVE_PRICE_UNIT_CURRENCY_KEY && broker_commission_discount ? "".concat(broker_commission_discount || 0, "%") : '',
    wholeSaleBrokerDiscountAmount: wholesale_broker_commission_discount_amount || 0,
    haveWholeSaleBrokerDiscountValue: !!Number(wholesale_broker_commission_discount_amount || 0),
    currentPayWholeSaleBrokerDiscountAmount: (currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.wholesale_broker_commission_discount_amount) || 0,
    wholeSaleBrokerDiscountPercentageText: wholesale_broker_commission_type !== JOVE_PRICE_UNIT_CURRENCY_KEY && wholesale_broker_commission_discount ? "".concat(wholesale_broker_commission_discount || 0, "%") : '',
    overridePriceText: formatPriceText(override_price, currency),
    differencePriceText: formatPriceText(difference_price, currency),
    combineUnderwritingFeeAmount: addNumbers(Number(underwriting_fee_amount || 0), Number(admin_fee || 0)),
    currentPayCombineUnderwritingFeeAmount: addNumbers(Number((currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.admin_fee) || 0), Number((currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.underwriting_fee_amount) || 0)),
    totalDiscountText: formatPriceText(totalDiscount, currency),
    haveTotalDiscountValue: !!Number(totalDiscount || 0),
    customDiscountText: formatPriceText(customDiscountAmount, currency),
    haveCustomDiscountValue: !!Number(customDiscountAmount || 0)
  };
  priceData = _objectSpread(_objectSpread({}, priceData), {}, {
    currentPayCombineUnderwritingFeeText: formatPriceText(priceData.currentPayCombineUnderwritingFeeAmount, currency),
    currentPayWholeSaleBrokerFeeText: formatPriceText((_priceData = priceData) === null || _priceData === void 0 ? void 0 : _priceData.currentPayWholeSaleBrokerFeeAmount, currency),
    currentPayWholeSaleBrokerDiscountText: formatPriceText((_priceData2 = priceData) === null || _priceData2 === void 0 ? void 0 : _priceData2.currentPayWholeSaleBrokerDiscountAmount, currency),
    combineUnderwritingFeeText: formatPriceText((_priceData3 = priceData) === null || _priceData3 === void 0 ? void 0 : _priceData3.combineUnderwritingFeeAmount, currency),
    wholeSaleBrokerFeeText: formatPriceText((_priceData4 = priceData) === null || _priceData4 === void 0 ? void 0 : _priceData4.wholeSaleBrokerFeeAmount, currency),
    wholeSaleBrokerDiscountText: formatPriceText((_priceData5 = priceData) === null || _priceData5 === void 0 ? void 0 : _priceData5.wholeSaleBrokerDiscountAmount, currency)
  }); // Discount

  priceData.totalHaveDiscount = !!(currentPayData !== null && currentPayData !== void 0 && currentPayData.original_total) && (currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.original_total) !== (currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.total);
  priceData.subTotalHaveDiscount = !!(currentPayData !== null && currentPayData !== void 0 && currentPayData.original_price) && (currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.original_price) !== (currentPayData === null || currentPayData === void 0 ? void 0 : currentPayData.price); // Billing schedule

  data.billing_schedule = ((data === null || data === void 0 ? void 0 : data.billing_schedule) || []).map(function (item, index) {
    var _getPaymentScheduleSt;

    var _ref6 = item.price || {},
        currency = _ref6.currency,
        total = _ref6.total,
        price = _ref6.price,
        tax = _ref6.tax,
        admin_fee = _ref6.admin_fee,
        processing_fee = _ref6.processing_fee,
        underwriting_fee_amount = _ref6.underwriting_fee_amount;

    var broker_paid_amount = item.broker_paid_amount;
    var itemBrokerCommmissionChain = generateBrokerCommissionChainList(item.price);
    var totalBrokerFee = 0;
    var totalDiscount = 0;
    itemBrokerCommmissionChain.forEach(function (item) {
      totalBrokerFee = addNumbers(totalBrokerFee, item.broker_fee_amount);
      totalDiscount = addNumbers(totalDiscount, item.broker_commission_discount_amount);
    });
    item.monthText = formatCommonDateStr(item.statement_date);
    item.totalText = formatPriceText(total, currency);
    item.priceText = formatPriceText(price, currency);
    item.taxText = formatPriceText(tax, currency);
    item.adminFeeText = formatPriceText(admin_fee, currency);
    item.processingFeeText = formatPriceText(processing_fee, currency);
    item.brokerFeeText = item.partnerFeeText = formatPriceText(totalBrokerFee, currency);
    item.underwritingFeeText = formatPriceText(underwriting_fee_amount, currency);
    item.combineUnderwritingFeeText = formatPriceText(addNumbers(underwriting_fee_amount || 0, admin_fee || 0), currency);
    item.index = ++index;
    item.paymentStatusText = (_getPaymentScheduleSt = getPaymentScheduleStatusMap()[item.payment_status]) === null || _getPaymentScheduleSt === void 0 ? void 0 : _getPaymentScheduleSt.label;
    item.paymentTimeText = transformDateStrToTimeString(item.paid_at, {
      format: 'MMM.DD.YYYY'
    });
    item.totalDiscountText = formatPriceText(totalDiscount, currency);
    item.brokerCommmissionChain = itemBrokerCommmissionChain;
    item.paidAmountText = !!broker_paid_amount || broker_paid_amount === 0 ? formatPriceText(broker_paid_amount, currency) : '-';
    return item;
  });
  return {
    data: data,
    priceData: priceData
  };
};

export var handleCommonInsurerPriceData = function handleCommonInsurerPriceData(data, priceData) {
  var _data$price, _priceInfoData$PROFES, _priceInfoData$PROFES2, _priceInfoData$PUBLIC, _priceInfoData$PUBLIC2, _priceInfoData$EMPLOY, _priceInfoData$EMPLOY2, _priceInfoData$EXCESS, _priceInfoData$EXCESS2, _priceInfoData$GOODS_, _priceInfoData$GOODS_2, _priceInfoData$CMR_CO, _priceInfoData$CMR_CO2, _priceInfoData$FIDELI, _priceInfoData$FIDELI2, _priceInfoData$DRIVER, _priceInfoData$DRIVER2, _priceInfoData$DIRECT, _priceInfoData$DIRECT2, _priceInfoData$EMPLOY3, _priceInfoData$EMPLOY4, _priceInfoData$PROPER, _priceInfoData$PROPER2, _priceInfoData$PACKAG, _priceInfoData$PACKAG2, _aggregate_covers_pri5, _aggregate_covers_pri6, _aggregate_covers_pri7, _aggregate_covers_pri8, _aggregate_covers_pri9, _aggregate_covers_pri10, _aggregate_covers_pri11, _aggregate_covers_pri12, _covers_price$BI_COW_, _covers_price$BI_COW_2;

  var _data$covers_price = data.covers_price,
      covers_price = _data$covers_price === void 0 ? {} : _data$covers_price,
      _data$aggregate_cover = data.aggregate_covers_price,
      aggregate_covers_price = _data$aggregate_cover === void 0 ? {} : _data$aggregate_cover,
      _data$covers_options = data.covers_options,
      covers_options = _data$covers_options === void 0 ? {} : _data$covers_options;

  var _getLocalTranslation = getLocalTranslation(),
      $t = _getLocalTranslation.$t; // const priceInfoData = [PROVIDER_SOURCE().ACCELERANT_GIT.value].includes(data?.provider_code) ? aggregate_covers_price : covers_price;


  var priceInfoData = aggregate_covers_price;
  var currency = data === null || data === void 0 ? void 0 : (_data$price = data.price) === null || _data$price === void 0 ? void 0 : _data$price.currency;
  var pi = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PROFES = priceInfoData[PROFESSIONAL_INDEMNITY]) === null || _priceInfoData$PROFES === void 0 ? void 0 : _priceInfoData$PROFES.price) || 0;
  var piOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PROFES2 = priceInfoData[PROFESSIONAL_INDEMNITY]) === null || _priceInfoData$PROFES2 === void 0 ? void 0 : _priceInfoData$PROFES2.original_price) || 0;
  var pl = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PUBLIC = priceInfoData[PUBLIC_LIABILITY]) === null || _priceInfoData$PUBLIC === void 0 ? void 0 : _priceInfoData$PUBLIC.price) || 0;
  var plOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PUBLIC2 = priceInfoData[PUBLIC_LIABILITY]) === null || _priceInfoData$PUBLIC2 === void 0 ? void 0 : _priceInfoData$PUBLIC2.original_price) || 0;
  var el = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$EMPLOY = priceInfoData[EMPLOYERS_LIABILITY]) === null || _priceInfoData$EMPLOY === void 0 ? void 0 : _priceInfoData$EMPLOY.price) || 0;
  var elOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$EMPLOY2 = priceInfoData[EMPLOYERS_LIABILITY]) === null || _priceInfoData$EMPLOY2 === void 0 ? void 0 : _priceInfoData$EMPLOY2.original_price) || 0;
  var exl = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$EXCESS = priceInfoData[EXCESS_LEVEL]) === null || _priceInfoData$EXCESS === void 0 ? void 0 : _priceInfoData$EXCESS.price) || 0;
  var exlOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$EXCESS2 = priceInfoData[EXCESS_LEVEL]) === null || _priceInfoData$EXCESS2 === void 0 ? void 0 : _priceInfoData$EXCESS2.original_price) || 0;
  var git = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$GOODS_ = priceInfoData[GOODS_IN_TRANSIT]) === null || _priceInfoData$GOODS_ === void 0 ? void 0 : _priceInfoData$GOODS_.price) || 0;
  var gitOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$GOODS_2 = priceInfoData[GOODS_IN_TRANSIT]) === null || _priceInfoData$GOODS_2 === void 0 ? void 0 : _priceInfoData$GOODS_2.original_price) || 0;
  var cmr = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$CMR_CO = priceInfoData[CMR_COVER]) === null || _priceInfoData$CMR_CO === void 0 ? void 0 : _priceInfoData$CMR_CO.price) || 0;
  var cmrOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$CMR_CO2 = priceInfoData[CMR_COVER]) === null || _priceInfoData$CMR_CO2 === void 0 ? void 0 : _priceInfoData$CMR_CO2.original_price) || 0;
  var fidelity = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$FIDELI = priceInfoData[FIDELITY_CRIME]) === null || _priceInfoData$FIDELI === void 0 ? void 0 : _priceInfoData$FIDELI.price) || 0;
  var fidelityOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$FIDELI2 = priceInfoData[FIDELITY_CRIME]) === null || _priceInfoData$FIDELI2 === void 0 ? void 0 : _priceInfoData$FIDELI2.original_price) || 0;
  var driversNeg = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$DRIVER = priceInfoData[DRIVERS_NEGLIGENCE]) === null || _priceInfoData$DRIVER === void 0 ? void 0 : _priceInfoData$DRIVER.price) || 0;
  var driversNegOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$DRIVER2 = priceInfoData[DRIVERS_NEGLIGENCE]) === null || _priceInfoData$DRIVER2 === void 0 ? void 0 : _priceInfoData$DRIVER2.original_price) || 0;
  var directorsOfficers = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$DIRECT = priceInfoData[DIRECTORS_OFFICERS_COVER]) === null || _priceInfoData$DIRECT === void 0 ? void 0 : _priceInfoData$DIRECT.price) || 0;
  var directorsOfficersOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$DIRECT2 = priceInfoData[DIRECTORS_OFFICERS_COVER]) === null || _priceInfoData$DIRECT2 === void 0 ? void 0 : _priceInfoData$DIRECT2.original_price) || 0;
  var employmentPracticesLiability = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$EMPLOY3 = priceInfoData[EMPLOYMENT_PRACTICES_COVER]) === null || _priceInfoData$EMPLOY3 === void 0 ? void 0 : _priceInfoData$EMPLOY3.price) || 0;
  var employmentPracticesLiabilityOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$EMPLOY4 = priceInfoData[EMPLOYMENT_PRACTICES_COVER]) === null || _priceInfoData$EMPLOY4 === void 0 ? void 0 : _priceInfoData$EMPLOY4.original_price) || 0;
  var property = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PROPER = priceInfoData[PROPERTY_COVER_TYPE_LIST]) === null || _priceInfoData$PROPER === void 0 ? void 0 : _priceInfoData$PROPER.price) || 0;
  var propertyOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PROPER2 = priceInfoData[PROPERTY_COVER_TYPE_LIST]) === null || _priceInfoData$PROPER2 === void 0 ? void 0 : _priceInfoData$PROPER2.original_price) || 0;
  var packages = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PACKAG = priceInfoData[PACKAGE_COVER]) === null || _priceInfoData$PACKAG === void 0 ? void 0 : _priceInfoData$PACKAG.price) || 0;
  var packagesOrigin = (priceInfoData === null || priceInfoData === void 0 ? void 0 : (_priceInfoData$PACKAG2 = priceInfoData[PACKAGE_COVER]) === null || _priceInfoData$PACKAG2 === void 0 ? void 0 : _priceInfoData$PACKAG2.original_price) || 0;
  var gitAgg = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri5 = aggregate_covers_price[GOODS_IN_TRANSIT]) === null || _aggregate_covers_pri5 === void 0 ? void 0 : _aggregate_covers_pri5.price) || 0;
  var gitAggOrigin = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri6 = aggregate_covers_price[GOODS_IN_TRANSIT]) === null || _aggregate_covers_pri6 === void 0 ? void 0 : _aggregate_covers_pri6.original_price) || 0;
  var cmrAgg = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri7 = aggregate_covers_price[CMR_COVER]) === null || _aggregate_covers_pri7 === void 0 ? void 0 : _aggregate_covers_pri7.price) || 0;
  var cmrAggOrigin = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri8 = aggregate_covers_price[CMR_COVER]) === null || _aggregate_covers_pri8 === void 0 ? void 0 : _aggregate_covers_pri8.original_price) || 0;
  var plAgg = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri9 = aggregate_covers_price[PUBLIC_LIABILITY]) === null || _aggregate_covers_pri9 === void 0 ? void 0 : _aggregate_covers_pri9.price) || 0;
  var plAggOrigin = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri10 = aggregate_covers_price[PUBLIC_LIABILITY]) === null || _aggregate_covers_pri10 === void 0 ? void 0 : _aggregate_covers_pri10.original_price) || 0;
  var elAgg = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri11 = aggregate_covers_price[EMPLOYERS_LIABILITY]) === null || _aggregate_covers_pri11 === void 0 ? void 0 : _aggregate_covers_pri11.price) || 0;
  var elAggOrigin = (aggregate_covers_price === null || aggregate_covers_price === void 0 ? void 0 : (_aggregate_covers_pri12 = aggregate_covers_price[EMPLOYERS_LIABILITY]) === null || _aggregate_covers_pri12 === void 0 ? void 0 : _aggregate_covers_pri12.original_price) || 0; // BUSINESS_INTERUPTION

  var biIcow = (covers_price === null || covers_price === void 0 ? void 0 : (_covers_price$BI_COW_ = covers_price[BI_COW_COVER]) === null || _covers_price$BI_COW_ === void 0 ? void 0 : _covers_price$BI_COW_.price) || 0;
  var biIcowOrigin = (covers_price === null || covers_price === void 0 ? void 0 : (_covers_price$BI_COW_2 = covers_price[BI_COW_COVER]) === null || _covers_price$BI_COW_2 === void 0 ? void 0 : _covers_price$BI_COW_2.original_price) || 0; // Special logic

  var cmrOptions = (covers_options === null || covers_options === void 0 ? void 0 : covers_options[CMR_COVER]) || [];

  if (cmrOptions.length === 2) {
    if (cmrOptions.some(function (item) {
      return item.value === 0;
    })) {
      cmrOptions.forEach(function (item) {
        if (item.value > 0) {
          item.label = $t('text:included');
        }
      });
    }
  }

  var priceInfo = _objectSpread(_objectSpread({}, priceData), {}, {
    currency: currency,
    pi: pi,
    pl: pl,
    el: el,
    exl: exl,
    git: git,
    cmr: cmr,
    piOrigin: piOrigin,
    plOrigin: plOrigin,
    elOrigin: elOrigin,
    exlOrigin: exlOrigin,
    gitOrigin: gitOrigin,
    cmrOrigin: cmrOrigin,
    gitAgg: gitAgg,
    gitAggOrigin: gitAggOrigin,
    cmrAgg: cmrAgg,
    cmrAggOrigin: cmrAggOrigin,
    plAgg: plAgg,
    plAggOrigin: plAggOrigin,
    elAgg: elAgg,
    elAggOrigin: elAggOrigin,
    piOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[PROFESSIONAL_INDEMNITY]) || [],
    piPriceText: formatPriceText(pi, currency),
    piOriginPriceText: formatPriceText(piOrigin, currency),
    plOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[PUBLIC_LIABILITY]) || [],
    plPriceText: formatPriceText(pl, currency),
    plOriginPriceText: formatPriceText(plOrigin, currency),
    plAggPriceText: formatPriceText(plAgg, currency),
    plAggOriginPriceText: formatPriceText(plAggOrigin, currency),
    elOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[EMPLOYERS_LIABILITY]) || [],
    elPriceText: formatPriceText(el, currency),
    elOriginPriceText: formatPriceText(elOrigin, currency),
    elAggPriceText: formatPriceText(elAgg, currency),
    elAggOriginPriceText: formatPriceText(elAggOrigin, currency),
    exlOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[EXCESS_LEVEL]) || [],
    exlPriceText: formatPriceText(exl, currency),
    exlOriginPriceText: formatPriceText(exlOrigin, currency),
    gitOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[GOODS_IN_TRANSIT]) || [],
    gitPriceText: formatPriceText(git, currency),
    gitOriginPriceText: formatPriceText(gitOrigin, currency),
    gitAggPriceText: formatPriceText(gitAgg, currency),
    gitAggOriginPriceText: formatPriceText(gitAggOrigin, currency),
    cmrOptions: cmrOptions,
    cmrPriceText: formatPriceText(cmr, currency),
    cmrOriginPriceText: formatPriceText(cmrOrigin, currency),
    cmrAggPriceText: formatPriceText(cmrAgg, currency),
    cmrAggOriginPriceText: formatPriceText(cmrAggOrigin, currency),
    fidelity: fidelity,
    fidelityOrigin: fidelityOrigin,
    fidelityOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[FIDELITY_CRIME]) || [],
    fidelityPriceText: formatPriceText(fidelity, currency),
    fidelityOriginPriceText: formatPriceText(fidelityOrigin, currency),
    driversNeg: driversNeg,
    driversNegOrigin: driversNegOrigin,
    driversNegOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[DRIVERS_NEGLIGENCE]) || [],
    driversNegPriceText: formatPriceText(driversNeg, currency),
    driversNegOriginPriceText: formatPriceText(driversNegOrigin, currency),
    directorsOfficers: directorsOfficers,
    directorsOfficersOrigin: directorsOfficersOrigin,
    directorsOfficersOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[DIRECTORS_OFFICERS_COVER]) || [],
    directorsOfficersPriceText: formatPriceText(directorsOfficers, currency),
    directorsOfficersOriginPriceText: formatPriceText(directorsOfficersOrigin, currency),
    employmentPracticesLiability: employmentPracticesLiability,
    employmentPracticesLiabilityOrigin: employmentPracticesLiabilityOrigin,
    employmentPracticesLiabilityOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[DIRECTORS_OFFICERS_COVER]) || [],
    employmentPracticesLiabilityPriceText: formatPriceText(employmentPracticesLiability, currency),
    employmentPracticesLiabilityOriginPriceText: formatPriceText(employmentPracticesLiabilityOrigin, currency),
    property: property,
    propertyOrigin: propertyOrigin,
    propertyOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[DIRECTORS_OFFICERS_COVER]) || [],
    propertyPriceText: formatPriceText(property, currency),
    propertyOriginPriceText: formatPriceText(propertyOrigin, currency),
    biIcow: biIcow,
    biIcowOrigin: biIcowOrigin,
    biIcowOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[BUSINESS_INTERUPTION]) || [],
    biIcowPriceText: formatPriceText(biIcow, currency),
    biIcowOriginPriceText: formatPriceText(biIcowOrigin, currency),
    packages: packages,
    packagesOrigin: packagesOrigin,
    packagesOptions: (covers_options === null || covers_options === void 0 ? void 0 : covers_options[PACKAGE_COVER]) || [],
    packagesPriceText: formatPriceText(packages, currency),
    packagesOriginPriceText: formatPriceText(packagesOrigin, currency)
  });

  data.covers_price = appendCoverageItemData(covers_price, data);
  data.aggregate_covers_price = appendCoverageItemData(aggregate_covers_price, data);
  return [data, priceInfo];
};

var appendCoverageItemData = function appendCoverageItemData(coverageInfoItem, data) {
  if (!coverageInfoItem) {
    return coverageInfoItem;
  }

  Object.keys(coverageInfoItem).forEach(function (key) {
    if (key === LEGAL_EXPENSES_COVER) {
      coverageInfoItem[key].insurerText = data === null || data === void 0 ? void 0 : data.legal_expenses_insurer;
    }
  });
  return coverageInfoItem;
};

export var combineQuoteCoverOptionList = function combineQuoteCoverOptionList(allCoverOption, priceData, config) {
  if (allCoverOption !== null && allCoverOption !== void 0 && allCoverOption.data && priceData) {
    var _getLocalTranslation2 = getLocalTranslation(),
        $t = _getLocalTranslation2.$t;

    var coverData = _objectSpread({}, allCoverOption.data);

    Object.keys(coverData).forEach(function (coverKey) {
      var _coverData$coverKey;

      var temp = (_coverData$coverKey = coverData[coverKey]) === null || _coverData$coverKey === void 0 ? void 0 : _coverData$coverKey.find(function (item) {
        var _priceData$covers;

        return item.value === ((_priceData$covers = priceData.covers) === null || _priceData$covers === void 0 ? void 0 : _priceData$covers[coverKey]);
      });
      coverData[coverKey] = (coverData[coverKey] || []).map(function (item) {
        if (config !== null && config !== void 0 && config.useDefault) {
          item.selected = temp ? temp.value === item.value : item.is_default;
        } else {
          item.selected = (temp === null || temp === void 0 ? void 0 : temp.value) === item.value;
        }

        if (item.lang_key) {
          item.label = $t(item.lang_key);
        }

        return item;
      });
    });
    priceData.cover_wordings = allCoverOption === null || allCoverOption === void 0 ? void 0 : allCoverOption.cover_wordings;
    priceData.covers_options = coverData;
  }
};